/**
 * Fastly assigns the visitor's A/B bucket (`ab_bucket`) on their first request, before the cookie banner.
 * This only handles a decline: someone who refuses the A/B category is never counted, so the cookie becomes
 * `control` and every request after that shows the original. The page already on screen is left as it is.
 */
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { isAbTestingEnabled } from './experiments';
import { hasAnsweredConsent, CONSENT_EVENT, hasAbConsent } from './consent';

const COOKIE = 'ab_bucket';
const EXPIRY_DAYS = 42;

export function syncBucketCookie() {
  if (hasAbConsent() !== false || !hasAnsweredConsent() || !isAbTestingEnabled()) {
    return;
  }

  if (Cookies.get(COOKIE) === 'control') {
    return;
  }

  Cookies.set(COOKIE, 'control', {
    secure: window.location.protocol === 'https:',
    expires: EXPIRY_DAYS,
    sameSite: 'lax',
    path: '/',
  });
}

export function useBucketCookie() {
  useEffect(() => {
    syncBucketCookie();
    window.addEventListener(CONSENT_EVENT, syncBucketCookie);
    return () => window.removeEventListener(CONSENT_EVENT, syncBucketCookie);
  }, []);
}
